/** @jsxImportSource @emotion/react */
import Image from 'next/image';

export const Logo: React.FC = () => {
  return (
    <div css={{ display: 'flex', padding: '0 var(--offset) 3rem' }}>
      <Image
        css={{ margin: 'auto', maxWidth: '100%' }}
        alt="vitafy logo"
        width={400}
        height={200}
        unoptimized
        src={'https://cdn11.vitafy.de/vitafy/image/upload///vitafy/logos/logo-10-years.svg'}
      />
    </div>
  );
};
